import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { IconMenu, MenuItem, IconButton, FontIcon } from 'material-ui';
import { equals, path, prop, not, propOr, find, propEq, isEmpty, without, omit } from 'ramda';
import ExternalLinksContainer from './external-links/external-links-container';

const Dropdown = props => {
  const {
    updateMMProp,
    downloadSingleFile,
    updateMM,
    MMReducer,
    selectedFilesUrls,
    isEditable,
    updateStateForViewers, // for viewers
    containerStateForViewers, // for viewers
    isSupplier,
    forLocationOrProductPages,
    findPhotosForTag, // for location and product pages
  } = props;

  const removeCloudDrive = isEditable ? propOr([], 'selectedFiles', MMReducer).filter(file => file.mediaType !== 'CloudDrive') :
    propOr([], 'selectedFiles', containerStateForViewers).filter(file => file.mediaType !== 'CloudDrive');
  const numberOfSelectedFiles = isEditable ? path(['selectedFiles', 'length'], MMReducer) : path(['selectedFiles', 'length'], containerStateForViewers);
  const numberOfAllFiles = forLocationOrProductPages ? prop('length', findPhotosForTag) : path(['media', 'length'], MMReducer);
  const filesToUse = forLocationOrProductPages ? findPhotosForTag : prop('media', MMReducer);
  const plusIcon = <FontIcon className="tc-icon-add" style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }} />;

  const options = [];

  if (isEditable) {
    options.push({
      text: <span>
        {plusIcon}
        Add File Link
      </span>,
      action: () => updateMMProp({ showFileLink: true }),
    });
    options.push({
      text: <span>
        {plusIcon}
        Add Storage Link
      </span>,
      action: () => updateMMProp({ showStorageLink: true }),
    });
    if (isSupplier && !forLocationOrProductPages) {
      options.push({
        text: <span>
          <FontIcon className="tc-icon-tag" style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }} />
          Manage Tags
        </span>,
        action: () => updateMMProp({ managingTags: true }),
      });
    }
  }

  if (numberOfAllFiles > 0) {
    const checkIfAllFilesAreSelected = isEditable ? equals(path(['selectedFiles', 'length'], MMReducer), prop('length', filesToUse)) : equals(path(['selectedFiles', 'length'], containerStateForViewers), filesToUse.length);
    options.push({
      text: checkIfAllFilesAreSelected ?
        <span>
          <FontIcon className="tc-icon-check_box_outline_blank" style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }} />
          Deselect All
        </span> :
        <span>
          <FontIcon className="tc-icon-check-square-o" style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }} />
          Select All
        </span>,
      action: () => {
        if (isEditable) updateMMProp({ selectedFiles: checkIfAllFilesAreSelected ? [] : filesToUse });
        else { updateStateForViewers('selectedFiles', checkIfAllFilesAreSelected ? [] : filesToUse); }
      },
    });
  }

  if (numberOfSelectedFiles > 0) {
    options.push({
      text: <span>
        <FontIcon className="tc-icon-get_app" style={{ color: '#00a1ba', fontSize: '14px', marginRight: '5px' }} />
        Download {prop('length', removeCloudDrive)} {prop('length', removeCloudDrive) === 1 ? 'File' : 'Files'}
          {(isEditable ? find(propEq('mediaType', 'CloudDrive'), MMReducer.selectedFiles) : find(propEq('mediaType', 'CloudDrive'), containerStateForViewers.selectedFiles)) ?
            ' (CloudDrives cannot be downloaded)' : ''}
      </span>,
      action: () => {
        if (isEditable) {
          updateMMProp({ selectedFiles: removeCloudDrive });
        } else {
          updateStateForViewers('selectedFiles', removeCloudDrive);
        }
        downloadSingleFile(removeCloudDrive.map(file => ({ url: file.url, fileName: file.name, fileType: file.mediaType })));
      },
    });
    if (isEditable) {
      options.push({
        text: <span>
          <FontIcon className="tc-icon-delete2" style={{ color: '#ff4081', fontSize: '14px', marginRight: '5px' }} />
          Delete {equals(numberOfSelectedFiles, numberOfAllFiles) ? 'All' : numberOfSelectedFiles} {equals(numberOfSelectedFiles, 1) && !equals(numberOfSelectedFiles, numberOfAllFiles) ? 'File' : 'Files'}
        </span>,
        action: () => {
          const confirmed = confirm('Are you sure you want to delete?');
          if (confirmed) {
            const removeSelectedFiles = (forLocationOrProductPages ? MMReducer.media : filesToUse).filter(file => selectedFilesUrls.indexOf(file.url) === -1);
            const removeKeysFromSelectedFiles = MMReducer.selectedFiles.map(file => omit(['index'], file));
            const removeSelectedFilesFromFilteredFiles = without(removeKeysFromSelectedFiles, MMReducer.filteredMedia);
            updateMMProp({
              savingMedia: true,
              selectedFiles: [],
              media: removeSelectedFiles,
              filteredMedia: removeSelectedFilesFromFilteredFiles,
            });
            updateMM({
              updateField: 'media',
              updateBody: removeSelectedFiles,
            });
          }
        },
      });
    }
  }

  return (
    <span style={{ float: 'right' }}>
      {
        not(isEmpty(options)) ?
          <IconMenu
            iconButtonElement={
              <IconButton
                iconClassName="tc-icon-more-vert"
                iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              />
            }
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
            style={{ display: 'inline-block', marginTop: isSupplier ? '-23px' : '-13px', verticalAlign: isSupplier ? 'middle' : '' }}
          >
            {options.map((option, i) => <MenuItem key={i} primaryText={option.text} onTouchTap={option.action} />)}
          </IconMenu> : <span/>
      }
      <ExternalLinksContainer
        MMReducer={MMReducer}
        updateMMProp={updateMMProp}
        onCancel={() => updateMMProp({
          showFileLink: false,
          showStorageLink: false,
        })}
        onFileLinkSubmit={(file) => {
          MMReducer.media.unshift({
            url: file.url,
            mediaType: file.fileType,
            name: file.fileName,
            size: MMReducer.showFileLink ? 'external' : undefined,
            storageProvider: MMReducer.showStorageLink ? file.storageProvider : undefined,
            username: MMReducer.showStorageLink ? prop('username', file) : undefined,
            password: MMReducer.showStorageLink ? prop('password', file) : undefined,
            created_at: new Date(),
          });
          updateMMProp({
            savingMedia: true,
            showFileLink: false,
            showStorageLink: false,
          });
          updateMM({
            updateField: 'media',
            updateBody: MMReducer.media,
          });
        }}
      />
    </span>
  );
};

Dropdown.propTypes = {
  updateMMProp: PropTypes.func,
  downloadSingleFile: PropTypes.func,
  updateMM: PropTypes.func,
  MMReducer: PropTypes.object,
  selectedFilesUrls: PropTypes.array,
  isEditable: PropTypes.bool,
  updateStateForViewers: PropTypes.func,
  containerStateForViewers: PropTypes.object,
  isSupplier: PropTypes.bool,
  forLocationOrProductPages: PropTypes.bool,
  findPhotosForTag: PropTypes.array,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
});

export default connect(mapStateToProps)(Dropdown);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/dropdown.jsx